<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-item>
        <ion-label>Click on a Lesson to select</ion-label>
      </ion-item>
      <ion-grid>
        <ion-row>
          <div *ngFor="let tql of lessonList">
            <ion-col class="grid-block" (click)="onLessonSelect($event,tql)">
              <div *ngIf="tql?.LessonPictureContent_GUID != ''">
                <img
                  class="media-thumbnail-img border-radius"
                  style="
                    padding-top: 0px;
                    padding-right: 5px;
                    padding-left: 5px;
                    padding-bottom: 5px;
                    padding-top: 5px;
                  "
                  (error)="globals.onThumbnailError($event,'blank.jpg')"
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + tql?.LessonPictureContent_GUID + '.jpg'}}"
                />
              </div>

              <div *ngIf="tql?.LessonPictureContent_GUID == ''">
                <img
                  class="media-thumbnail-img border-radius"
                  style="
                    padding-top: 0px;
                    padding-right: 5px;
                    padding-left: 5px;
                    padding-bottom: 5px;
                    padding-top: 5px;
                  "
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/blank.jpg'}}"
                />
              </div>

              <div
                style="
                  padding: 5px;
                  padding-top: 0px;
                  padding-bottom: 5px;
                  width: 200px;
                  height: 25px;
                "
              >
                <ion-label text-wrap>{{tql.Lesson_Description}}</ion-label
                ><br />
              </div>
            </ion-col>
          </div>
        </ion-row>
      </ion-grid>
      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
